import React, { Component } from "react";
import PropTypes from "prop-types";
import DealershipDetails from "./dealershipdetails/DealershipDetails";
import { withTranslation } from "react-i18next";
import AcceptTermsAndConditions from "./termsAndConditions/AcceptTermsAndConditions";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import LoadTermsAndConditions from "./termsAndConditions/LoadTermsAndConditions";
import SubNav from "../../shared/subnav/SubNav";

class DealerBusinessSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: this.props.startingTab,
      renderPage: false,
    };
  }

  componentDidMount() {
    this.props.user.businessSettingsPage
      ? this.setState({ selectedTab: this.props.user.businessSettingsPage })
      : this.props.user.updateBusinessSettingsTab(this.state.selectedTab);
    this.setState({ renderPage: true });
  }

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
    this.props.user.updateBusinessSettingsTab(selectedTab);
    this.props.resetFromPending();
  };

  getTabs() {
    return [
      {
        menuName: this.props.t("ProgressBar.empMembership"),
        enabled: true,
        id: "empMembership",
      },
      {
        menuName: this.props.t("ProgressBar.dealershipDetails"),
        enabled: true,
        id: "dealership-details",
      },
    ];
  }

  renderTermsConditionsTab() {
    return this.props.isDealerAcceptingTerms ? (
      <AcceptTermsAndConditions {...this.props} />
    ) : (
      <>
        <div className="pagePaddingLeft pagePaddingTop">
          <InfoIconWithMessage
            message={this.props.t("AcceptTermsConditions.subheader")}
          />
        </div>
        <LoadTermsAndConditions {...this.props} />
      </>
    );
  }

  render() {
    return (
      this.state.renderPage && (
        <>
          <SubNav
            dashboard={false}
            selectedTab={this.state.selectedTab}
            title={this.props.t("GlobalNavBar.settings")}
            action={this.handleTabChange}
            tabs={this.getTabs()}
            restrictDropdown={this.props.restrictDropdown}
            {...this.props}
          />
          <div className="pageWrapper">
            {this.state.selectedTab === 0 && this.renderTermsConditionsTab()}
            {this.state.selectedTab === 1 && (
              <DealershipDetails
                {...this.props}
                filteredDealers={this.props.filteredDealers.filter(
                  (d) => d.isOnboarded
                )}
              />
            )}
          </div>
        </>
      )
    );
  }
}

DealerBusinessSettings.propTypes = {
  startingTab: PropTypes.number,
  user: PropTypes.shape({
    businessSettingsPage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    updateBusinessSettingsTab: PropTypes.func,
  }).isRequired,
  resetFromPending: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isDealerAcceptingTerms: PropTypes.bool,
  restrictDropdown: PropTypes.bool,
  filteredDealers: PropTypes.arrayOf(
    PropTypes.shape({
      isOnboarded: PropTypes.bool,
    })
  ),
};

DealerBusinessSettings.defaultProps = {
  startingTab: 0,
  isDealerAcceptingTerms: false,
  restrictDropdown: false,
  filteredDealers: [],
};

export default withTranslation("emp")(DealerBusinessSettings);
